import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { ContainerConfirmEmailHeader } from "./ConfirmEmailStyles.styled";
import {
  ContainerIconGreen,
  // ContainerIconRed,
  ContainerStatus,
  StatusEmail,
  StatusEmailTime,
} from "./EmailStatusStyles.styled"; // Стилі
import { ConfirmEmailByToken } from "../../API/ConfirmDataUser/ConfirmDataUser";
import { LogoApp } from "../../Components/LogoApp/LogoApp";
import { DoneIcon } from "./Icons";
// import { NotConfirmedEmailUserIcon } from "../../Components/secure/setIcons";

export const ConfirmEmailUser = () => {
  const { verificationToken } = useParams();
  const [confirmEmail, setConfirmEmail] = useState<boolean | null>(null);
  const [isInvalidToken, setIsInvalidToken] = useState<boolean>(false);

  useEffect(() => {
    const emailConfirmed = sessionStorage.getItem("emailConfirmed");

    if (emailConfirmed === "true") {
      setConfirmEmail(true);
      return;
    }

    const confirmEmailProcess = async () => {
      try {
        if (!verificationToken) return;

        const response = await ConfirmEmailByToken(verificationToken);

        if (response?.message === "Verification successful") {
          setConfirmEmail(true);
          sessionStorage.setItem("emailConfirmed", "true");

          return;
        }

        // Якщо сервер повернув помилку — токен недійсний
        setIsInvalidToken(true);

        setConfirmEmail(false);
      } catch (error) {
        console.error("Error confirming email:", error);
        setConfirmEmail(false);
      }
    };

    confirmEmailProcess();
  }, [verificationToken, isInvalidToken]);

  // Якщо confirmEmail ще не визначено
  if (confirmEmail === null) {
    return <p>Loading...</p>;
  }

  return (
    <>
      <ContainerConfirmEmailHeader>
        <LogoApp />
      </ContainerConfirmEmailHeader>

      <main>
        <ContainerStatus>
          <>
            <ContainerIconGreen>
              <DoneIcon />
            </ContainerIconGreen>
            <StatusEmail>Confirmed</StatusEmail>
            <StatusEmailTime />
          </>
          {/* {confirmEmail ? (
            <>
              <ContainerIconGreen>
                <DoneIcon />
              </ContainerIconGreen>
              <StatusEmail>Confirmed</StatusEmail>
              <StatusEmailTime />
            </>
          ) : (
            <>
              <ContainerIconRed>
                <NotConfirmedEmailUserIcon />
              </ContainerIconRed>
              <StatusEmail>Time expired</StatusEmail>
            </>
          )} */}
        </ContainerStatus>
      </main>
    </>
  );
};
